var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rad-badge rad-badge-status"},[_c('span',{staticClass:"rad-badge-status-dot",class:_vm.activeClassName}),(_vm.text)?_c('span',{staticClass:"rad-badge-status-text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }